import React from 'react';

export default function Path1(){


    return(
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="451.2" viewBox="0 0 46.9 451.2">
                <g id="_1" data-name="1" transform="translate(-26.7 -348.8)">
                    <g id="Group_2" data-name="Group 2">
                    <g id="Group_1" data-name="Group 1">
                        <path id="Path_1" data-name="Path 1" d="M64.8,364.2v8.7h3.3v2.3a4.481,4.481,0,0,1-4.5,4.5H58a8.56,8.56,0,0,0-6.4,2.9V361.5h6.3l-7.3-12.7-7.3,12.7h6.3v29.8a8.4,8.4,0,0,0-6.4-2.9H37.6a4.481,4.481,0,0,1-4.5-4.5v-3.5a5.457,5.457,0,0,0,4.4-5.3,5.4,5.4,0,0,0-10.8,0,5.457,5.457,0,0,0,4.4,5.3v3.5a6.594,6.594,0,0,0,6.6,6.6h5.6a6.445,6.445,0,0,1,6.4,6.4v8.9a6.57,6.57,0,0,0-5.5,6.5,6.5,6.5,0,0,0,13,0,6.732,6.732,0,0,0-5.5-6.5V388.2a6.445,6.445,0,0,1,6.4-6.4h5.6a6.594,6.594,0,0,0,6.6-6.6v-2.3h3.3v-8.7H64.8ZM31.9,378.4a3.3,3.3,0,1,1,3.3-3.3A3.2,3.2,0,0,1,31.9,378.4Zm15-18.9,3.6-6.3,3.6,6.3ZM55,412.3a4.4,4.4,0,1,1-4.4-4.4A4.439,4.439,0,0,1,55,412.3Zm16.4-41.5H67v-4.4h4.4Z" fill="#3c6fa5"/>
                    </g>
                    </g>
                    <rect id="Rectangle_1" data-name="Rectangle 1" width="2.1" height="381.7" transform="translate(49.5 418.3)" fill="#3b6fa5"/>
                    <circle id="Ellipse_1" data-name="Ellipse 1" cx="6.7" cy="6.7" r="6.7" transform="translate(43.8 681.6)" fill="#3b6fa5"/>
                    <circle id="Ellipse_2" data-name="Ellipse 2" cx="5.2" cy="5.2" r="5.2" transform="translate(45.3 683.1)" fill="#fff"/>
                </g>
                </svg>
        </div>
    )
}